import PropTypes from 'prop-types'
import React, { createContext, useContext, useEffect, useState } from 'react'

const defaultValue = {}
const BreakpointContext = createContext(defaultValue)

const queries = {
  xs: '(max-width: 375px)',
  sm: '(max-width: 600px)',
  fbs: '(max-width: 767px)',
  fb: '(max-width: 768px)', // phablet devices
  mds: '(max-width: 959px)',
  md: '(max-width: 960px)',
  lgs: '(max-width: 1249px)',
  lg: '(max-width: 1280px)',
  mdl: '(max-width: 1365px)',
  ls: '(max-width: 1440px)',
  l: '(max-width: 1680px)',
  xls: '(max-width: 1919px)',
  xl: '(max-width: 1920px)',
  xxl: '(min-width: 1920px)',
  or: '(orientation: portrait)', // we can check orientation also
}

const BreakpointProvider = ({ children }) => {
  const [queryMatch, setQueryMatch] = useState({})

  useEffect(() => {
    localStorage.getItem &&
      localStorage.getItem('log_breakpoint_provider') &&
      console.info(queryMatch)
  }, [queryMatch])

  useEffect(() => {
    const mediaQueryLists = {}
    const keys = Object.keys(queries)
    let isAttached = false

    const handleQueryListener = () => {
      const updatedMatches = keys.reduce((acc, media) => {
        acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches)
        return acc
      }, {})
      setQueryMatch(updatedMatches)
    }

    if (window && global.matchMedia) {
      const matches = {}
      keys.forEach((media) => {
        if (typeof queries[media] === 'string') {
          mediaQueryLists[media] = global.matchMedia(queries[media])
          matches[media] = mediaQueryLists[media].matches
        } else {
          matches[media] = false
        }
      })
      setQueryMatch(matches)
      isAttached = true
      keys.forEach((media) => {
        try {
          mediaQueryLists[media].addEventListener('change', handleQueryListener)
        } catch (error) {
          mediaQueryLists[media].addListener(handleQueryListener)
        }
      })
    }

    return () => {
      if (isAttached) {
        keys.forEach((media) => {
          if (typeof queries[media] === 'string') {
            try {
              mediaQueryLists[media].removeEventListener('change', handleQueryListener)
            } catch (error) {
              mediaQueryLists[media].removeListener(handleQueryListener)
            }
          }
        })
      }
    }
  }, [queries])

  return <BreakpointContext.Provider value={queryMatch}>{children}</BreakpointContext.Provider>
}
BreakpointProvider.propTypes = {
  children: PropTypes.object,
  queries: PropTypes.object,
}

function useBreakpoint() {
  const context = useContext(BreakpointContext)
  if (context === defaultValue) {
    throw new Error('useBreakpoint must be used within BreakpointProvider')
  }
  return context
}

export { useBreakpoint, BreakpointProvider }
